import {
  HistogramSeriesViewRequest,
  HistogramSeriesViewResponse,
} from 'generated/leaderboard-client';

import { leaderboardClient } from '@neptune/shared/core-apis-leaderboard-domain';

export function fetchHistogramSeries(
  request: HistogramSeriesViewRequest,
): Promise<HistogramSeriesViewResponse> {
  return leaderboardClient.getHistogramTimeSeriesView({ request });
}
